import { gql } from '@apollo/client';

export const GET_ALL_WORTHS = gql`
	query GetAllWorths(
		$page: Int!
		$limit: Int!
		$filters: WorthFilterInput
		$sort: [SortInput]
	) {
		worths(
			filters: $filters
			pagination: { page: $page, limit: $limit }
			sort: $sort
		) {
			items {
				id
				company {
					id
					gorkoId
					name
					isGorkoCommission
					isGorkoAbonent
					isGorkoHidden
					isGorkoDeleted
					commissionPriority
				}
				required
				value
				valueAuto
				wedding
				weddingAuto
				birthday
				birthdayAuto
				corporative
				newYear
				newYearAuto
				graduation
				createdAt
				updatedAt
			}
			pagination {
				currentPage
				totalPages
				totalCount
			}
		}
	}
`;
